import {sendAnalyticPayload, AnalyticEvent} from '../utils/analytic';

export const useSendChatAnalytic = () => {
  const handleMainSearchInputClick = () => {
    sendAnalyticPayload(
      {
        process: {
          Name: 'EV FIT',
          StepName: 'Ask me anything click',
          StepNumber: '',
        },
        link: {
          name: 'eVee destination page: Ask a question',
        },
      },
      AnalyticEvent.CTAClick,
    );
  };

  const handleChatCTAClick = () => {
    sendAnalyticPayload(
      {
        process: {
          Name: 'EV FIT',
          StepName: 'Ask me anything click',
          StepNumber: '',
        },
        link: {
          name: 'eVee floating button',
        },
      },
      AnalyticEvent.CTAClick,
    );
  };

  const handleHeroCardClick = (name?: string) => {
    sendAnalyticPayload(
      {
        process: {
          Name: 'EV FIT',
          StepName: 'Clicked on a page referral link within the chatbot',
          StepNumber: '',
        },
        link: {
          name: name,
        },
      },
      AnalyticEvent.CTAClick,
    );
  };

  const handleOnExitClick = () => {
    sendAnalyticPayload(
      {
        process: {
          Name: 'EV FIT',
          StepName: 'Exit Chatbot',
          StepNumber: '',
        },
        link: {
          name: 'Exit',
        },
      },
      AnalyticEvent.CTAClick,
    );
  };

  return {
    handleMainSearchInputClick,
    handleChatCTAClick,
    handleHeroCardClick,
    handleOnExitClick,
  };
};
